module.exports = __webpack_public_path__ + "static/img/Gift-Ribbon-PNG-Photos.bd5d504.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Gift-Ribbon-PNG-Photos.png
// module id = 337
// module chunks = 0